import type { UseMutationResult } from "@tanstack/react-query"
import { useMutation, useQueryClient } from "@tanstack/react-query"

import { queryKeys } from "~/api/cache"

import type {
  BatteryConcertCustomerContextDto,
  InitiateBatteryConcertApplicationDto,
} from "../dto/battery-concert-application.dto"
import { batteryProposalService } from "../services/battery-proposal.service"

/**
 * Reserve Now. Creates or reuses the Proposal's Concert customer and returns
 * the context the application form opens with. Either outcome moves the
 * server's setup status, so the status read is refetched both ways.
 */
export default function useInitiateBatteryConcertApplication(): UseMutationResult<
  BatteryConcertCustomerContextDto,
  unknown,
  { proposalId: string; body: InitiateBatteryConcertApplicationDto }
> {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ proposalId, body }) =>
      batteryProposalService.initiateConcertApplication(proposalId, body),
    onSettled: (_context, _error, { proposalId }) => {
      void queryClient.invalidateQueries({
        queryKey: queryKeys.batteryProposal.concertApplication(proposalId),
      })
    },
  })
}
